import { useEffect } from 'react'
import { useFeature } from '~/hooks/useFeature'

const WEBCHAT_SCRIPT_ID = 'botpress-webchat-inject'

// Webchat CDN URLs (always use cdn.botpress.cloud)
const DEFAULT_WEBCHAT_URL = 'https://cdn.botpress.cloud/webchat/v3.6/inject.js'
const DESK_WEBCHAT_URL = 'https://cdn.botpress.cloud/desk/webchat/v3.4/inject.js'

// Custom event that fires when the webchat script is ready
export const WEBCHAT_READY_EVENT = 'botpress-webchat-ready'

export const WebchatScriptProvider = () => {
  const useNewCdn = useFeature('webchat-cdn-switch')

  useEffect(() => {
    // Remove any existing webchat script
    const existingScript = document.getElementById(WEBCHAT_SCRIPT_ID)
    if (existingScript) {
      existingScript.remove()
      // Clean up window.botpress to force re-initialization
      delete (window as Window & { botpress?: unknown }).botpress
    }

    // Create and inject the new script
    const script = document.createElement('script')
    script.id = WEBCHAT_SCRIPT_ID
    script.src = useNewCdn ? DESK_WEBCHAT_URL : DEFAULT_WEBCHAT_URL
    script.async = true

    // Wait for script to load before dispatching ready event
    script.onload = () => {
      // Dispatch custom event to notify that webchat is ready
      window.dispatchEvent(new CustomEvent(WEBCHAT_READY_EVENT))
    }

    script.onerror = () => {
      // eslint-disable-next-line no-console
      console.error('Failed to load Botpress webchat script from:', script.src)
    }

    // Insert the script in the document head
    document.head.appendChild(script)

    // Cleanup function to remove script when component unmounts
    return () => {
      const scriptToRemove = document.getElementById(WEBCHAT_SCRIPT_ID)
      if (scriptToRemove) {
        scriptToRemove.remove()
      }
      delete (window as Window & { botpress?: unknown }).botpress
    }
  }, [useNewCdn])

  return null
}
